import { lazy } from 'react'
import BasicLayout from '../components/layout/BasicLayout'
import NothingLayout from '../components/layout/NothingLayout'
// import AdminLayout from '../components/layout/AdminLayout'
import routerConstants from '../constants/routerConstants'
import { role } from '../constants/roleConstants'
import { getUserRole, getManagedHeThongIds, getAccessToken } from '../utils/userUtils'

import {routeMenu} from './routeMenu'
import {routeRoleGroup} from './routeRoleGroup'
import {routeRoleAssignmentCopy} from './routeRoleAssignmentCopy'
import {routeDuAn} from './routeDuAn'
import {routeChiNhanh} from './routeChiNhanh'
import {routeKhoVatLy} from './routeKhoVatLy'
const resolveUserRole = (): string | undefined => {
  const cookieRole = getUserRole()
  if (cookieRole) return cookieRole

  try {
    const token = getAccessToken()
    if (!token) return undefined
    const payload = JSON.parse(atob(token.split('.')[1]))
    return payload?.role
  } catch {
    return undefined
  }
}

const user_role = resolveUserRole()
const managedIds = getManagedHeThongIds()


const routePublic: any[] = [
  { path: '/login', name: 'Login', exact: true, layout: NothingLayout, component: lazy(() => import('../components/login/Login')), },
  { path: '/login-all', name: 'LoginAll', exact: true, layout: NothingLayout, component: lazy(() => import('../components/login/LoginAll')), },
  { path: '/logout-all', name: 'LogoutAll', exact: true, layout: NothingLayout, component: lazy(() => import('../components/login/LoginAll')), },
  { path: '', name: '404', exact: true, layout: BasicLayout, component: lazy(() => import('../components/404/NotFound')), },
]

const routeUser: any[] = [
  { path: routerConstants.user.list, name: 'userList', exact: true, layout: BasicLayout, component: lazy(() => import('../components/admin/user/UserList')), },
  { path: routerConstants.user.add, name: 'userAdd', exact: true, layout: BasicLayout, component: lazy(() => import('../components/admin/user/UserAdd')), },
  { path: routerConstants.user.detail, name: 'userDetail', exact: false, layout: BasicLayout, component: lazy(() => import('../components/admin/user/UserDetail')), },
  { path: routerConstants.user.edit, name: 'userEdit', exact: false, layout: BasicLayout, component: lazy(() => import('../components/admin/user/UserUpdate')), },
]



const routeCommon: any[] = [
  { path: '/', name: 'Home', exact: true, layout: BasicLayout, component: lazy(() => import('../components/home/Home')), },
  { path: routerConstants.user.changePWD, name: 'UserChangePWD', exact: true, layout: BasicLayout, component: lazy(() => import('../components/admin/user/UserChangePWD')), },


]

const routeSupperAdminUser: any[] = [
  ...routeCommon,
  ...routeMenu,
  ...routeRoleGroup,
  ...routeDuAn,
  ...routeChiNhanh,
  ...routeKhoVatLy,
  ...routeRoleAssignmentCopy,
  ...routeUser,
  { path: '/sub-admin', name: 'subAdminList', exact: true, layout: BasicLayout, component: lazy(() => import('../components/admin/subAdmin/SubAdminList')) },
]


let routes: any[]
if (user_role === role.SUPPER_ADMIN) {
    routes = routeSupperAdminUser
} else if (managedIds && managedIds.length > 0) {
    // sub-admin: Nhân viên + Nhóm quyền + common
    routes = [...routeCommon, ...routeUser, ...routeRoleGroup]
} else {
    routes = routePublic
}
routes =
  [
    // ...routes_v3,
    ...routes,
    ...routePublic,
  ]

export default routes
